// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3C0LD","error":"Textarea_error__1FSEy","readonly":"Textarea_readonly__2ofGC","disabled":"Textarea_disabled__11vkF"};